import {
  DataGrid as Grid, GridColumnProps,
  MenuItem,
  SelectFilterComponent,
  SelectFloatingFilterComponent,
  StandardDialog,
  SubmitMenuItem,
} from '@roc/ui';
import { Pause, MoreVert } from '@material-ui/icons';
import { IconButton, ListItemIcon, ListItemText, Menu } from '@material-ui/core';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { useLenderBankInformationStore } from '../../hooks/useLenderBankInformationStore';
import { useRoutes } from '../../hooks/useRoutes';
import { useHistory } from 'react-router';
import { useStore } from '@roc/client-portal-shared/hooks';
import { CadencePauseForm } from './cadencePauseForm';
import Chip from '@material-ui/core/Chip';


const columns: GridColumnProps[] = [
  {
    field: 'cadence',
    headerName: 'Cadence',
    minWidth: 180,
    cellRenderer: 'cadenceNameRenderer',
    // filter: 'agTextColumnFilter',
    // floatingFilter: true,
    // floatingFilterComponentParams: {
    //   suppressFilterButton: true,
    // },
  },
  {
    field: 'totalPeople',
    headerName: 'Total Number of Prospects',
    minWidth: 120,
  },
  {
    field: 'activePeople',
    headerName: 'Active Prospects',
    minWidth: 120,
  },
  {
    field: 'unsubscribePeople',
    headerName: 'Unsubscribe Prospects',
    minWidth: 120,
  },
  {
    field: 'cadenceStatus',
    headerName: 'Cadence Status',
    minWidth: 120,
  },
  {
    field: 'assignedDate',
    headerName: 'Assigned Date',
    minWidth: 180,
  },
  {
    field: 'hasStepsDue',
    headerName: 'Due',
    minWidth: 80,
    cellRenderer: 'dueChipRenderer',
  },
  {
    headerName: 'Action',
    minWidth: 80,
    cellRenderer: 'actionCellRenderer',
  },
];


export const MyCadenceSection = observer(() => {
  const { cadenceRoutesConfig } = useRoutes();
  const { cadenceStore } = useStore();
  const { push } = useHistory();
  const cadenceRows = cadenceStore.templatesRows;

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);
  const [openPauseReason, setOpenPauseReason] = useState(false)
  const [selectedCadenceRow, setSelectedCadenceRow] = useState(null);


  const frameworkComponents = {
    selectFilter: SelectFilterComponent,
    selectFloatingFilter: SelectFloatingFilterComponent,
    cadenceNameRenderer: params => {
      const cadenceId = params?.data?.cadenceId?.toString();
      if (!cadenceId) return null;

      const cadenceDetailUrl = cadenceRoutesConfig.cadenceDetailsBackoffice(cadenceId).children.cadenceDetailBackoffice.url;
      return (
        <a
          href={cadenceDetailUrl}
          style={{ textDecoration: 'underline', color: '#5c94de', cursor: 'pointer' }}
          onClick={(e) => {
            e.preventDefault();
            push(cadenceDetailUrl);
          }}
        >
          {params.value}
        </a>
      );
    },
    actionCellRenderer: params => {
      return (
        <>
          <IconButton onClick={e => openMenu(e, params.node.data)}>
            <MoreVert color="primary" />
          </IconButton>
        </>
      );
    },
    dueChipRenderer: params => {
      const value = params?.value;

      return (
        <Chip
          label={value ? 'Yes' : 'No'}
          size="small"
          style={{
            backgroundColor: value ? '#f5da8c' : '#e0e0e0',
            color: '#555',
            fontWeight: 600,
          }}
        />
      );
    },
  };

  const openMenu = (event: React.MouseEvent<HTMLElement>, record) => {
    setSelectedCadenceRow(record)
    setAnchorEl(event.currentTarget);
  };


  const onFilterChanged = params => {
    const filterModel = params.api.getFilterModel();
    cadenceStore.cadenceTemplatesGridStore.setFilterModel(filterModel);
  };


  const onSortChanged = params => {
    const sortModel = params.api.getSortModel();
    cadenceStore.cadenceTemplatesGridStore.setSortModel(sortModel);
  };


  useEffect(() => {
    cadenceStore.cadenceTemplatesGridStore.resetAndFetchGridData();
  }, []);

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Grid
        columns={columns}
        rows={cadenceRows}
        frameworkComponents={frameworkComponents}
        onSortChanged={onSortChanged}
        onFilterChanged={onFilterChanged}
        isLoading={cadenceStore.cadenceTemplatesGridStore.isLoading}
        showFilters={cadenceStore.cadenceTemplatesGridStore.showFilters}
        sortModel={cadenceStore.cadenceTemplatesGridStore.sortModel}
        filterModel={cadenceStore.cadenceTemplatesGridStore.filterModel}
        paginationData={cadenceStore.cadenceTemplatesGridStore.gridData.meta}
        setPageNumber={cadenceStore.cadenceTemplatesGridStore.setPageNumber}
      />
      <Menu
        id="menu-appbar"
        getContentAnchorEl={null}
        anchorEl={anchorEl}
        keepMounted
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        open={menuOpen}
        onClose={handleMenuClose}
      >
        {selectedCadenceRow?.cadenceStatus === 'Active' &&
          <MenuItem
            testId={`assign-template`}
            onClick={() => {
              setOpenPauseReason(true)
            }}>
            <ListItemIcon>
              <Pause fontSize="small" />
            </ListItemIcon>
            <ListItemText>Pause Cadence</ListItemText>
          </MenuItem>
        }

        {selectedCadenceRow?.cadenceStatus === 'Paused' &&
          <MenuItem
            testId={`assign-template`}
            onClick={() => {
              cadenceStore.resumeCadence(selectedCadenceRow);
              handleMenuClose()
            }}>
            <ListItemIcon>
              <Pause fontSize="small" />
            </ListItemIcon>
            <ListItemText>Resume Cadence</ListItemText>
          </MenuItem>
        }
      </Menu>

      <StandardDialog
        open={openPauseReason}
        title="Pause Reason"
        maxWidth="sm"
        handleClose={() => {
          setOpenPauseReason(false);
          handleMenuClose();
        }}
        dialogContent={
          <CadencePauseForm
            onClose={() => {
              setOpenPauseReason(false);
              handleMenuClose();
            }}
            selectedCadence={selectedCadenceRow} />
        }
      />
    </>

  );
});
